module.exports = __webpack_public_path__ + "static/img/200100.92910ff2.png";